import { render } from "./sh-tabs-panel.vue?vue&type=template&id=84c74f60"
import script from "./sh-tabs-panel.vue?vue&type=script&lang=js"
export * from "./sh-tabs-panel.vue?vue&type=script&lang=js"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__